export function ToastStack({ toasts }) {
  return (
    <div className="fixed left-1/2 bottom-[120px] -translate-x-1/2 flex flex-col gap-2.5 z-[300]" role="status" aria-live="polite">
      {toasts.map((toast) => (
        <div
          key={toast.id}
          className={`glass-md px-4 py-3 rounded-[18px] border min-w-[260px] text-center text-xs md:text-sm animate-toast-in ${
            toast.tone === 'success' ? 'border-emerald-500/40' :
            toast.tone === 'action' ? 'border-orange-500/45' :
            'border-slate-400/25'
          }`}
        >
          <span>{toast.message}</span>
        </div>
      ))}
    </div>
  );
}
